<template>
    <b-modal ref="locEdit" id="modal1" :title="'Renaming ' + name"
        @shown="doFocus"
        hide-footer>
        <b-form @submit.prevent="close">
            <b-form-group label="Name" label-sr-only class="mb-0">
                <b-form-input ref="nameInput" type="text" v-model="name" />
            </b-form-group>
        </b-form>
    </b-modal>
</template>

<script>

export default {
    name: 'location',
    mounted: function() {
    },
    data() {
        return {
            id:0,
            name:'',
            lat:0,
            lon:0,
            address:'',
            meta:{},
            point:{},
            parent:{},
            traveltime:1,
            isochrones:{},
            isozeroscore:0,
            isoonescore:0,
            score: 0,
            geoid: 0,
            scoreUpdate: true,
        }
    },
    methods: {
        doFocus() {
            console.log('focusing', this.$refs.nameInput);
            this.$refs.nameInput.focus();
        },
        edit(){
          let self = this;
            self.$refs.locEdit.show();
        },
        close(){
          let self = this;
            self.$refs.locEdit.hide();
        },
        remove()
        {
            let self = this;
//            console.log("remove "+this.id);
//            console.log(this.$parent);
            this.parent.removeLocation(this);
//            console.log("remove done");
            self.$refs.locEdit.hide();
        },
        getName()
        {
            let self = this;
            if(self.name!='')
            {
                return self.name;
            }
            return "name="+self.lat + " " + self.lon;
        },
        scoreFormatted()
        {
            return parseInt(this.score);
        }
    }

}
</script>
